import React, { useState } from "react";
import Layout from "../components/layout";
import { motion } from "framer-motion";
// import { Script } from "gatsby";

interface LayoutContainerProps {
  // Add specific prop types if Layout expects specific props
  [key: string]: any; // If Layout accepts arbitrary props
}

const LayoutContainer: React.FC<LayoutContainerProps> = (props) => {
  const [pageLoaded, setPageLoaded] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 0 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 0 }}
      transition={{ duration: 0.6 }}
      onAnimationComplete={() => setPageLoaded(true)}
    >
      <Layout {...props} pageLoaded={pageLoaded} />
      {/*<Script
        src="https://www.bugherd.com/sidebarv2.js?apikey=1sefsllcyfxc6bogx6dz8q"
        async
      />*/}
    </motion.div>
  );
};

export default LayoutContainer;
